

















































































































































































































import IntroPage from '@/app/layout/IntroPage.vue';
import store from '@/app/store';
import Keycloak from '@/modules/auth/api/keycloak';
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api';
import { OrbitSpinner } from 'epic-spinners';

export default defineComponent({
    name: 'Home',
    metaInfo: {
        title: 'Home',
    },
    components: { OrbitSpinner, IntroPage },
    setup(props, { root }) {
        const open = ref(false);
        const isLoggingIn = ref(false);
        const isAuthenticated = computed(() => store.getters.auth.isAuthenticated);

        onMounted(() => {
            if (isAuthenticated.value) {
                root.$router.push({ name: 'platform', hash: '' });
            }
        });

        const useKeycloak = computed(() => Keycloak.isEnabled());
        const login = async () => {
            isLoggingIn.value = true;
            try {
                await Keycloak.login();
            } catch (e: any) {
                (root as any).$toastr.e(e.message, 'Error');
            } finally {
                isLoggingIn.value = false;
            }
        };
        const register = async () => {
            await Keycloak.register();
        };
        const keycloakAuthentication = async () => {
            if (store.getters.auth.isAuthenticated) {
                // Todo: Check login is ok and user is redirected to the right page
                root.$router.push({ name: 'platform', hash: '' });
            } else {
                isLoggingIn.value = true;
                try {
                    await Keycloak.login();
                } catch (e: any) {
                    (root as any).$toastr.e(e.message, 'Error');
                } finally {
                    isLoggingIn.value = false;
                }
            }
        };
        if (
            Keycloak.isEnabled() &&
            document.location.hash.length > 0 &&
            document.location.hash.match(/^#.*code=[a-zA-Z0-9]*/g)
        ) {
            keycloakAuthentication();
        }

        return { open, isAuthenticated, login, useKeycloak, register, isLoggingIn };
    },
});
